import {
	NUMBER_CF_TYPE,
	STORY_POINT_ESTIMATE_CF_TYPE,
} from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { FieldValidationInput, ValidationError } from '../../../../../types/validation.tsx';
import { POSITION_FIELD_DEFAULT_VALUE_INPUT } from '../../../constants.tsx';
import { hasDefaultValueProperty } from '../utils.tsx';
import { messages } from './messages.tsx';

const valid: ReadonlyArray<ValidationError> = [];

// This is a maximum allowed number by global issue create.
// It is still smaller than Number.MAX_SAFE_INTEGER
// There is no minimum allowed negative number, so
// you can have a negative number with magnitude great enough to lose precision.
// It is defined in the monolith at https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-custom-fields/src/main/java/com/atlassian/jira/issue/customfields/converters/DoubleConverterImpl.java
export const MAX_ALLOWED_NUMBER = 100000000000000;

const tooBigError: ReadonlyArray<ValidationError> = [
	{
		position: POSITION_FIELD_DEFAULT_VALUE_INPUT,
		messageDescriptor: messages.defaultValueTooLargeErrorNumber,
		values: { MAX_ALLOWED_NUMBER },
	},
];

const supportedFieldTypes: ReadonlyArray<string> = [NUMBER_CF_TYPE, STORY_POINT_ESTIMATE_CF_TYPE];

export const validateNumberFieldDefaultValue = ({
	field,
}: FieldValidationInput): ReadonlyArray<ValidationError> => {
	if (!hasDefaultValueProperty(field)) {
		return valid;
	}
	const { defaultValue, type } = field;
	if (!supportedFieldTypes.includes(type) || !defaultValue || typeof defaultValue !== 'string') {
		return valid;
	}

	if (Number(defaultValue) > MAX_ALLOWED_NUMBER) {
		return tooBigError;
	}

	return valid;
};
